<template>
    <div class="p-5">
        <div class="d-flex justify-content-between align-items-center mb-5">
            <div class="c-title">Campaigns</div>
            <div class="c-tab-list">
                <TabItem
                    v-for="tab in tabs"
                    :key="tab.value"
                    :data="tab"
                    :activeTab="activeTab"
                    @handleChangeTab="handleChangeTab"
                />
            </div>
            <RouterLink to="/campaigns/create" v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_ADD)">
                <button class="btn c-btn-add">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
            </RouterLink>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead class="c-thead">
                    <tr>
                        <th
                            scope="col"
                            class="h-name"
                            style="cursor: pointer"
                            @click="onSort(SORT_ITEMS.name)"
                        >
                            Campaign name
                            <span
                                class="ml-1"
                                v-if="currentSortBy === SORT_ITEMS.name"
                            >
                                <i
                                    :class="
                                        currentSortOrder === SORT_ORDER.asc
                                            ? 'fa-chevron-up'
                                            : 'fa-chevron-down'
                                    "
                                    class="fa mt-2"
                                    style="font-size: 14px"
                                ></i>
                            </span>
                        </th>
                        <th v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_VIEW)"
                            scope="col"
                            class="text-right h-amount pr-5"
                            style="cursor: pointer"
                            @click="onSort(SORT_ITEMS.amount)"
                        >
                            Amount raised
                            <span
                                class="ml-1"
                                v-if="currentSortBy === SORT_ITEMS.amount"
                            >
                                <i
                                    :class="
                                        currentSortOrder === SORT_ORDER.asc
                                            ? 'fa-chevron-up'
                                            : 'fa-chevron-down'
                                    "
                                    class="fa mt-2"
                                    style="font-size: 14px"
                                ></i>
                            </span>
                        </th>
                        <th
                            scope="col"
                            class="h-date"
                            style="cursor: pointer"
                            @click="onSort(SORT_ITEMS.date)"
                        >
                            Start date
                            <span
                                class="ml-1"
                                v-if="currentSortBy === SORT_ITEMS.date"
                            >
                                <i
                                    :class="
                                        currentSortOrder === SORT_ORDER.asc
                                            ? 'fa-chevron-up'
                                            : 'fa-chevron-down'
                                    "
                                    class="fa mt-2"
                                    style="font-size: 14px"
                                ></i>
                            </span>
                        </th>
                        <th scope="col" class="h-end-date">End date</th>
                        <th scope="col" class="h-type">Type</th>
                        <th scope="col" class="h-status">Status</th>
                      <th></th>
                    </tr>
                </thead>
                <tbody v-if="displayCampaigns.length">
                    <TableItem
                        v-for="item in displayCampaigns"
                        :key="item.campaign_id"
                        :data="item"
                        @manualDonate="manualDonate"
                    />
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="6" class="text-center">No data</td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-center" v-if="totalPage > 1">
                <CustomPagination
                    :activePage="currentPage"
                    :totalPage="totalPage"
                    @paginationHandle="onClickPagging"
                ></CustomPagination>
            </div>

            <modal-campaign-manual-donation
                v-if="isOpenManualDonateModal"
                :data="manualDonateData"
                @close="isOpenManualDonateModal = false" />
        </div>
    </div>
</template>

<script>
import TabItem from './components/TabItem.vue';
import TableItem from './components/TableItem.vue';
import { TAB_IDS } from './constants/index';
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import CustomPagination from '@/commons/CustomPagination/CustomPagination.vue';
import { EventBus } from '@/utils/event-bus';
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";
import ModalCampaignManualDonation from "@/components/campaigns/components/ModalCampaignManualDonation.vue";

const SORT_ITEMS = {
    name: 1,
    date: 2,
    amount: 3,
};
const SORT_ORDER = {
    asc: 1,
    desc: -1,
};

export default {
    name: 'ListView',
    computed: {
        Authorizations() {
            return Authorizations
        },
        DibbleJS() {
            return DibbleJS
        }
    },
    components: {
        ModalCampaignManualDonation,
        CustomPagination,
        TabItem,
        TableItem,
    },
    data() {
        return {
            SORT_ITEMS,
            SORT_ORDER,
            currentSortBy: SORT_ITEMS.date,
            currentSortOrder: SORT_ORDER.asc,
            tabs: [
                { value: TAB_IDS.ALL, label: 'All' },
                { value: TAB_IDS.ACTIVE, label: 'Active' },
                { value: TAB_IDS.INACTIVE, label: 'Inactive' },
                { value: TAB_IDS.COMPLETED, label: 'Completed' },
                { value: TAB_IDS.EVENTS, label: 'Events' },
            ],
            activeTab: TAB_IDS.ALL,
            originCampaigns: [],

            totalDisplayCampaigns: [],
            displayCampaigns: [],
            totalPage: 0,
            currentPage: 1,
            itemPerPage: 8,
            search_keyword: this.$route.query.q || '',
            isOpenManualDonateModal: false,
            manualDonateData: null,
        };
    },
    methods: {
        onSort(value) {
            if (value === this.currentSortBy) {
                this.currentSortOrder =
                    this.SORT_ORDER.asc === this.currentSortOrder
                        ? this.SORT_ORDER.desc
                        : this.SORT_ORDER.asc;
            } else {
                this.currentSortBy = value;
                this.currentSortOrder = SORT_ORDER.asc;
                this.currentPage = 1;
            }

            switch (this.currentSortBy) {
                case SORT_ITEMS.name:
                    this.totalDisplayCampaigns.sort((a, b) => {
                        if (a.title < b.title) {
                            return -this.currentSortOrder;
                        }
                        if (a.title > b.title) {
                            return this.currentSortOrder;
                        }
                        return 0;
                    });
                    break;

                case SORT_ITEMS.date:
                    this.totalDisplayCampaigns.sort((a, b) => {
                        if (
                            this.$moment(a.start_date) <
                            this.$moment(b.start_date)
                        ) {
                            return -this.currentSortOrder;
                        }
                        if (
                            this.$moment(a.start_date) >
                            this.$moment(b.start_date)
                        ) {
                            return this.currentSortOrder;
                        }
                        return 0;
                    });
                    break;

                case SORT_ITEMS.amount:
                    this.totalDisplayCampaigns.sort((a, b) => {
                        if (a.curr_amount < b.curr_amount) {
                            return -this.currentSortOrder;
                        }
                        if (a.curr_amount > b.curr_amount) {
                            return this.currentSortOrder;
                        }
                        return 0;
                    });
                    break;
            }

            this.displayCampaigns = this.totalDisplayCampaigns.slice(
                (this.currentPage - 1) * this.itemPerPage,
                this.currentPage * this.itemPerPage
            );
        },
        handleChangeTab(tabIndex) {
            this.activeTab = tabIndex;
            switch (tabIndex) {
                case TAB_IDS.ALL:
                    this.totalDisplayCampaigns = this.originCampaigns;
                    break;

                case TAB_IDS.ACTIVE:
                    this.totalDisplayCampaigns = this.originCampaigns.filter(
                        (item) => item.status === TAB_IDS.ACTIVE
                    );
                    break;

                case TAB_IDS.INACTIVE:
                    this.totalDisplayCampaigns = this.originCampaigns.filter(
                        (item) => item.status === TAB_IDS.INACTIVE
                    );
                    break;

                case TAB_IDS.COMPLETED:
                    this.totalDisplayCampaigns = this.originCampaigns.filter(
                        (item) => item.status === TAB_IDS.COMPLETED
                    );
                    break;

                case TAB_IDS.EVENTS:
                    this.totalDisplayCampaigns = this.originCampaigns.filter(
                        (item) => item.type === 3
                    );
                    break;
            }

            this.currentPage = 1;
            this.totalPage = Math.ceil(
                this.totalDisplayCampaigns.length / this.itemPerPage
            );
            this.onClickPagging({
                pageIndex: 1,
            });
        },
        getAllCampaign() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getAllCampaign,
            };

            if (this.search_keyword) {
                data.search_string = this.search_keyword;
            }
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.originCampaigns = response.campaigns.map((item) => ({
                        ...item,
                        curr_amount: parseInt(
                            item.curr_amount
                                .replace('$', '')
                                .replaceAll(',', '')
                        ),
                    }));
                    this.totalDisplayCampaigns = this.originCampaigns;
                    this.displayCampaigns = this.totalDisplayCampaigns.slice(
                        0,
                        this.itemPerPage
                    );
                    this.totalPage = Math.ceil(
                        this.totalDisplayCampaigns.length / this.itemPerPage
                    );
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        onClickPagging(page) {
            this.currentPage = page.pageIndex;
            this.displayCampaigns = this.totalDisplayCampaigns.slice(
                (page.pageIndex - 1) * this.itemPerPage,
                page.pageIndex * this.itemPerPage
            );
        },
        manualDonate(data) {
            this.isOpenManualDonateModal = true;
            this.manualDonateData = data;
        },
    },
    watch: {
        $route(value) {
            if (this.search_keyword) {
                if (value.query.q !== this.search_keyword) {
                    this.search_keyword = value.query.q;
                    this.getAllCampaign();
                }
            }
        },
    },
    created() {
        this.getAllCampaign();

        EventBus.$on('searchCampaigns', (keyword) => {
            this.search_keyword = keyword;
            this.getAllCampaign();
        });
    },
};
</script>

<style lang="scss" scoped>
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-thead {
    th {
        color: #41b8dc;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-name {
            width: 25%;
        }
        &.h-amount {
            width: 20%;
        }
        &.h-date {
            width: 15%;
        }
        &.h-end-date {
            width: 15%;
        }
        &.h-type {
            width: 10%;
        }
        &.h-status {
            width: 10%;
        }
    }
}
</style>
